export enum VerificationMethod {
  Password = 'Password',
  EmailCode = 'EmailCode',
  PhoneCode = 'PhoneCode',
}
